import { HttpRequest } from "@angular/common/http";

export interface IRetryRequestConfig extends HttpRequest<unknown> {
  retries?: number;
  maxRetries?: number;
}

export const DEFAULT_MAX_RETRIES = 1;

let retries = 0;

export const globalRetries = (): number => retries;

export const increaseGlobalRetries = (): void => {
  retries += 1;
};
